/* tslint:disable:no-string-literal */

import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RedirectCommand } from '@angular/router';
import { Observable } from 'rxjs';
import { Annotation, AnnotationService, ToastrService} from './../../shared/index';

@Injectable()
export class AnnotationResolve  {
    constructor(
        private _annotationService: AnnotationService,
        private router: Router,
        private _toastrService: ToastrService
    ) { }

    resolve(route: ActivatedRouteSnapshot): Observable<Annotation> | Promise<Annotation> | Annotation | { redirectTo: string[] } {
        const annotationId: number = +route.params['annotationId'];

        const annotation: Annotation = this._annotationService.annotations.GetByMap(0, annotationId);
        if (annotation) {
            return annotation;
        } else {
            //this.router.navigate(['/annotation']);
            this._toastrService.displayToastrMessage('warning', 'Annotation Not Found');
            return { redirectTo: ['/annotation'] }; // RedirectCommand syntax
        }
    }
}
